import React from 'react'
import styles from './FeedbackPreview.module.less'
import Flex from 'antd/lib/flex'

type FeedbackPreviewProps = {
    correctAnswer: string
    correctAnswerFeedback?: string
    incorrectAnswerFeedback?: string
    isTrainingMode: boolean
}

export const FeedbackPreview: React.FC<FeedbackPreviewProps> = ({
    correctAnswer,
    correctAnswerFeedback,
    incorrectAnswerFeedback,
    isTrainingMode,
}) => {
    if (isTrainingMode) {
        return (
            <Flex vertical gap={12}>
                <div className={styles.feedbackContainer}>
                    <Flex vertical gap={8}>
                        {correctAnswer ? (
                            <div>
                                <span className={styles['correct-answer-label']}>
                                    Correct answer:{' '}
                                </span>
                                <span className={styles['correct-answer-value']}>
                                    {correctAnswer}
                                </span>
                            </div>
                        ) : null}
                        <div>
                            <span className={styles['feedback']}>Feedback on </span>
                            <span className={styles['feedback-correct-answer-label']}>
                                correct answer
                            </span>
                            <div className={styles['feedback-value']}>{correctAnswerFeedback}</div>
                        </div>
                    </Flex>
                </div>
                <div className={styles.feedbackContainer}>
                    <span className={styles['feedback']}>Feedback on </span>
                    <span className={styles['feedback-incorrect-answer-label']}>
                        incorrect answer
                    </span>
                    <div className={styles['feedback-value']}>{incorrectAnswerFeedback}</div>
                </div>
            </Flex>
        )
    } else if (correctAnswer) {
        return (
            <div className={styles.feedbackContainer}>
                <span className={styles['correct-answer-label']}>Correct answer: </span>
                <span className={styles['correct-answer-value']}>{correctAnswer}</span>
            </div>
        )
    }
    return null
}
